import {type} from '@ibe/store/util';
import {Action} from '@ngrx/store';

export const ActionTypes = {
	LOAD_COUNTRY_CODES: type('[CountryState] LOAD_COUNTRY_CODES'),
	LOAD_COUNTRY_CODES_SUCCESS: type('[CountryState] LOAD_COUNTRY_CODES_SUCCESS'),
	LOAD_COUNTRY_CONVERSION_CODES: type('[CountryState] LOAD_COUNTRY_CONVERSION_CODES'),
	LOAD_COUNTRY_CONVERSION_CODES_SUCCESS: type('[CountryState] LOAD_COUNTRY_CONVERSION_CODES_SUCCESS'),
	LOAD_US_AIRPORTS: type('[CountryState] LOAD_US_AIRPORTS'),
	LOAD_US_AIRPORTS_SUCCESS: type('[CountryState] LOAD_US_AIRPORTS_SUCCESS'),
	LOAD_US_STATES: type('[CountryState] LOAD_US_STATES'),
	LOAD_US_STATES_SUCCESS: type('[CountryState] LOAD_US_STATES_SUCCESS'),
	LOAD_SCHENGEN_COUNTRY_CODES: type('[CountryState] LOAD_SCHENGEN_COUNTRY_CODES'),
	LOAD_SCHENGEN_COUNTRY_CODES_SUCCESS: type('[CountryState] LOAD_SCHENGEN_COUNTRY_CODES_SUCCESS'),
	LOAD_EU_COUNTRY_CODES: type('[CountryState] LOAD_EU_COUNTRY_CODES'),
	LOAD_EU_COUNTRY_CODES_SUCCESS: type('[CountryState] LOAD_EU_COUNTRY_CODES_SUCCESS')
};

export class LoadCountryCodes implements Action {
	readonly type = ActionTypes.LOAD_COUNTRY_CODES;

	constructor(public payload?) {}
}

export class LoadCountryCodesSuccess implements Action {
	readonly type = ActionTypes.LOAD_COUNTRY_CODES_SUCCESS;

	constructor(public payload: any) {}
}

export class LoadCountryConversionCodes implements Action {
	readonly type = ActionTypes.LOAD_COUNTRY_CONVERSION_CODES;

	constructor(public payload?) { }
}

export class LoadCountryConversionCodesSuccess implements Action {
	readonly type = ActionTypes.LOAD_COUNTRY_CONVERSION_CODES_SUCCESS;

	constructor(public payload: any) {}
}

export class LoadUSAirports implements Action {
	readonly type = ActionTypes.LOAD_US_AIRPORTS;

	constructor(public payload?) { }
}

export class LoadUSAirportsSuccess implements Action {
	readonly type = ActionTypes.LOAD_US_AIRPORTS_SUCCESS;

	constructor(public payload: any) {}
}

export class LoadUSStates implements Action {
	readonly type = ActionTypes.LOAD_US_STATES;

	constructor(public payload?) { }
}

export class LoadUSStatesSuccess implements Action {
	readonly type = ActionTypes.LOAD_US_STATES_SUCCESS;

	constructor(public payload: any) {}
}

export class LoadSchengenCountryCodes implements Action {
	readonly type = ActionTypes.LOAD_SCHENGEN_COUNTRY_CODES;

	constructor(public payload?) { }
}

export class LoadSchengenCountryCodesSuccess implements Action {
	readonly type = ActionTypes.LOAD_SCHENGEN_COUNTRY_CODES_SUCCESS;

	constructor(public payload: any) { }
}

export class LoadEUCountryCodes implements Action {
	readonly type = ActionTypes.LOAD_EU_COUNTRY_CODES;

	constructor(public payload?) { }
}

export class LoadEUCountryCodesSuccess implements Action {
	readonly type = ActionTypes.LOAD_EU_COUNTRY_CODES_SUCCESS;

	constructor(public payload: any) { }
}

export type Actions = LoadCountryCodes
	| LoadCountryCodesSuccess
	| LoadCountryConversionCodes
	| LoadCountryConversionCodesSuccess
	| LoadUSAirports
	| LoadUSAirportsSuccess
	| LoadUSStates
	| LoadUSStatesSuccess
	| LoadSchengenCountryCodes
	| LoadSchengenCountryCodesSuccess
	| LoadEUCountryCodes
	| LoadEUCountryCodesSuccess
	;
